export default "__VITE_ASSET__366ed44d__"